import { ChevronRightIcon, FolderIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import Image from "src/components/elements/Image";
import LeftMenuItemLink from "src/components/navigation/leftNavigation/LeftMenuItemLink";
import { isSVGString } from "src/helpers";
import { classNames } from "src/helpers/classNames";

const LeftMenuItemGroupTitle = ({ data, imageClassName, setImageClassName, group_id, page_id, isUnderLine, isSubGroup = false, avoidUnderlineHover = false, setIsSubmenu, isSubmenu, searchTerm, dropdownArrowClass, isCollapsed }) => {
  const isActive = (data) => {
    if (!isSubGroup && !isSubmenu && data.submenu.some((item) => `${window.location.origin}${item.link}` === window.location.href)) {
      return data.submenu.some((item) => `${window.location.origin}${item.link}` === window.location.href);
    }

    if (isSubGroup) {
      if (isSubmenu || data?.groupId !== group_id) return false;
      return data.submenu.some((item) => item.slug === page_id);
    } else {
      if (isSubmenu || data?.slug !== group_id) return false;
      return data.slug === page_id || (data.submenu && data.submenu.some((item) => item.slug === page_id)) || data.submenu.some((item) => item.submenu && item.submenu.some((nestedItem) => nestedItem.slug === page_id));
    }
  };

  const shouldShowAsGroup = data.submenu.length > 1 || data.subMenuFilteredDown || data.submenu.some((item) => item.is_group || item.submenu);
  const tooltipId = `group-title-tooltip-${data._id || data.slug || data.name?.replace(/\s+/g, '-')}`;

  return (
    <>
      {shouldShowAsGroup ? (
        <>
          <button
            type="button"
            data-tooltip-id={isCollapsed ? tooltipId : undefined}
            data-tooltip-content={isCollapsed ? data.name : undefined}
            data-tooltip-place="right"
            className={classNames(
              "duration-20 flex min-h-10 py-2 w-full select-none items-center rounded text-leftNavTextColor transition-all duration-300 hover:bg-leftNavActiveColor hover:text-leftNavActiveTextColor",
              isCollapsed ? "justify-center px-1" : "justify-between space-x-1 px-3",
              isActive(data) ? "bg-leftNavActiveColor !text-leftNavActiveTextColor" : "",
            )}
            onClick={() => setIsSubmenu(!isSubmenu)}>
            <div className={classNames("flex items-center min-w-0 mr-1", isCollapsed ? "justify-center !mr-0 flex-initial" : "flex-1")}>
              {(data.image || isCollapsed) && (
                <div
                  className={classNames("nav-icon flex-shrink-0 flex items-center justify-center [&_svg]:h-full [&_svg]:w-full", isCollapsed ? "h-6 w-6 mr-0" : "h-5 w-5 mr-2", isSVGString(data.image) ? "" : "flex items-center justify-center", imageClassName)}>
                  {data.image ? (
                    isSVGString(data.image) ? (
                      <div
                        className="h-full w-full"
                        dangerouslySetInnerHTML={{ __html: data.image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"') }}
                      />
                    ) : (
                      <Image
                        src={data.image}
                        alt={"Menu image"}
                        classes={classNames(imageClassName, "h-full w-full object-contain")}
                        onError={() => setImageClassName("hidden")}
                      />
                    )
                  ) : (
                    <FolderIcon className="h-6 w-6 stroke-[1.7]" />
                  )}
                </div>
              )}
              {!isCollapsed && (
                <span
                  className={classNames(
                    "min-w-0 flex-1 text-left font-medium leading-tight break-words",
                    data.type === "group" && data.submenu[0].type === "internal" ? "" : !avoidUnderlineHover ? "visited:text-purple-700 group-hover/link:underline" : "",
                    isUnderLine && !avoidUnderlineHover ? "group-hover/link:underline" : "",
                    isActive(data) ? "text-leftNavActiveTextColor" : "",
                  )}>
                  {data.name}
                </span>
              )}
            </div>
            {!isCollapsed && <ChevronRightIcon className={classNames("transition-rotate h-6 w-6 flex-shrink-0 rounded-md stroke-2 p-1 duration-200", dropdownArrowClass, isSubmenu ? "rotate-90" : "")} />}
          </button>
          {isCollapsed && (
            <Tooltip
              id={tooltipId}
              place="right"
              positionStrategy="fixed"
              offset={10}
              delayShow={150}
              className="!z-[99999] !rounded-md !px-2.5 !py-1.5 !text-xs !font-medium !shadow-xl"
              style={{ backgroundColor: "#1f2937", color: "#ffffff", zIndex: 99999 }}
            />
          )}
        </>
      ) : (
        <LeftMenuItemLink
          data={data.submenu[0]}
          image={data.submenu[0]?.image || data.image || null}
          group_id={group_id}
          page_id={page_id}
          searchTerm={searchTerm}
          imageClassName={imageClassName}
          setImageClassName={setImageClassName}
          isCollapsed={isCollapsed}
        />
      )}
    </>
  );
};

export default LeftMenuItemGroupTitle;
